module.exports = "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjI4IiB2aWV3Qm94PSIwIDAgNDggMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJTd2l0Y2gvZmFsc2UvJiMyMzQ7JiMxODQ7JiMxNzY7JiMyMzU7JiMxNzk7JiMxODQ7Ij4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjI4IiByeD0iMTQiIGZpbGw9IiNEMUQ2REIiLz4KPGNpcmNsZSBpZD0iRWxsaXBzZSA0IiBjeD0iMTQiIGN5PSIxNCIgcj0iMTAiIGZpbGw9IndoaXRlIi8+CjwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/img_switch_off.svg
// module id = ToZi
// module chunks = 1